import React from 'react'
import Fire from '../../config/Fire';
import { withMyDataContext } from '../../context/DataProvider';
import InfiniteScroll from 'react-infinite-scroll-component';
import Aux from '../AuxFunctions';
import SingleNotification from './SingleNotification';
import CloseCircleOutlineIcon from 'mdi-react/CloseCircleOutlineIcon';
import Loader from '../Utilities/Loader';

class Notifications extends React.Component{

    constructor(props) {
        super(props);
        this.state = { 
            loading: false,
            finished: false,
            refreshing: false,
        }
    }

    componentDidMount(){
        try{
          if(this.props.myDataProvider.notifications[0]){
            if(this.props.myDataProvider.notifications[0].id &&  (this.props.myDataProvider.notifications[0].id !== this.props.myDataProvider.user.lastNotification)){
              Fire.shared.setNewLastNotification(this.props.myDataProvider.notifications[0].id)
            }
            this.props.myDataProvider.setNewNofitications(this.props.myDataProvider.notifications[0].id);
          }
        }catch(error){
          Aux.handleError(error)
        }
      }

    renderHeader = () => {
        try {
          if(this.props.myDataProvider.notifications.length <= 0 && !this.props.myDataProvider.notificationsLoading){
            return (
              <div style={{padding:10, justifyContent:"center",}}>
                <span style={{alignSelf:"center", fontSize:20}}>No Notifications...</span>
              </div> 
            );
          }else{
            return null;
          }
        } catch (error) {
          Aux.handleError(error)
        }
    };
    
    renderFooter = () => {
        try {
            // Check If Loading
            if (this.props.myDataProvider.notificationsLoading) {
                return null
            } else if(this.props.myDataProvider.notificationsFinished && this.props.myDataProvider.notifications.length > 0){
                return (
                    <div style={{padding:10, justifyContent:"center",}}>
                        <span style={{alignSelf:"center"}}>No more Notifications...</span>
                    </div> 
                );
            }else {
                return null;
            }
        } catch (error) {
          Aux.handleError(error)
        }
    };

    onEndReached = async() => {
        try{
            this.props.myDataProvider.getNotifications(false);
        }catch(error){
          Aux.handleError(error)
        }
    }

    getNewNotifications = async() => {
        try{
            this.props.myDataProvider.getNotifications(false);
        }catch(error){
          Aux.handleError(error);
        }
    }

    render(){
      return(
        <div id="scrollableDiv" style={{overflowX:"hidden", overflowY:"auto", height:"100%"}}>
            <InfiniteScroll
                
                style={{height:"100%"}}
                dataLength={this.props.myDataProvider.notifications.length}
                next={this.getNewNotifications}
                //height={400}
                scrollableTarget="scrollableDiv"
                hasMore={!this.props.myDataProvider.notificationsFinished}
                loader={<div style={{marginTop:20}}><Loader color={"#999"}></Loader></div>}
                endMessage={
                  <div style={{marginTop:20, marginBottom:20}}>
                    {this.props.myDataProvider.notifications.length === 0 ?
                      <p style={{ textAlign: 'center' }}>
                          <b>You don't have notifications yet</b>
                      </p>
                      :
                      <p style={{ textAlign: 'center' }}>
                          <b>There are no more notifications.</b>
                      </p>}
                  </div>
                }
                
                >
                <div style={{display:"flex", justifyContent:"space-between", margin:20,}}>
                  <h3>Notifications</h3>
                  {this.props.isMobile ? <CloseCircleOutlineIcon onClick={this.props.close} className="button-hover"></CloseCircleOutlineIcon> : null}
                </div>
                {this.props.myDataProvider.notifications.map((item, index) => (
                  <SingleNotification notification={item} key={item.id + index}></SingleNotification>
                    // <this.notificationRender post={item} key={item.id + index}></this.notificationRender>
                    // <RenderPost post={item} key={item.id + index} styles={this.props.styles}></RenderPost>
                ))} 
                
            </InfiniteScroll>
        </div>
      )
    }

}

export default withMyDataContext( Notifications);